import { useState, type FormEvent } from "react";
import { api } from "../lib/api";
import { useStudio } from "../lib/context";
import { errorMessage, Field } from "../components/ui";
import { BrandMark } from "../components/BrandMark";
import { ArrowRight, CheckCircle2, Languages, ShieldCheck, Sparkles } from "lucide-react";

export function Login() {
  const { signIn } = useStudio();
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;
    setBusy(true); setError(null);
    try {
      if (!sent) { await api.requestOtp(phone); setSent(true); }
      else { const r = await api.verifyOtp(phone, code); signIn(r.token, r.teacher); }
    } catch (err) { setError(errorMessage(err)); }
    finally { setBusy(false); }
  }

  return (
    <div className="login">
      <aside className="login-art" aria-hidden>
        <div className="row" style={{ gap: 12, fontFamily: "var(--display)", fontWeight: 700, fontSize: 18 }}><BrandMark size={36} onDark />Jang-e Studio</div>
        <div>
          <h1>Écrire les leçons que les élèves vont adorer.</h1>
          <p>Rédigez, illustrez, traduisez et relisez chaque notion du programme, avec l'aperçu exact de ce que verra l'élève sur son téléphone.</p>
        </div>
        <div className="feats">
          <div className="feat"><span><Sparkles size={17} /></span>Figures, formules et 3D interactives</div>
          <div className="feat"><span><Languages size={17} /></span>Français, wolof et autres langues du pays</div>
          <div className="feat"><span><ShieldCheck size={17} /></span>Relecture par un second enseignant avant publication</div>
        </div>
      </aside>
      <div className="login-form">
        <form className="stack appear" style={{ gap: 18 }} onSubmit={submit}>
          <div className="stack" style={{ gap: 6 }}>
            <BrandMark size={40} />
            <h1 style={{ fontSize: 24, marginTop: 10 }}>{sent ? "Saisissez votre code" : "Connexion"}</h1>
            <p className="muted">{sent ? `Code envoyé par SMS au ${phone}.` : "Espace des enseignants : rédaction, traduction et relecture des leçons."}</p>
          </div>
          <Field label="Numéro de téléphone">
            <input className="input" style={{ height: 44 }} type="tel" inputMode="tel" autoComplete="tel" placeholder="77 000 01 00" value={phone} onChange={(e) => setPhone(e.target.value)} disabled={sent} required minLength={7} maxLength={20} autoFocus />
          </Field>
          {sent && (
            <Field label="Code reçu par SMS" hint="Si ce numéro est enregistré comme enseignant, un code vient d'être envoyé.">
              <input className="input mono" style={{ height: 48, fontSize: 22, letterSpacing: "0.4em", textAlign: "center" }} inputMode="numeric" autoComplete="one-time-code" pattern="\d{6}" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} required autoFocus />
            </Field>
          )}
          {error && <div className="alert err" role="alert">{error}</div>}
          <button className="btn lg block" disabled={busy || (sent && code.length !== 6)}>{busy ? "…" : sent ? <><CheckCircle2 size={17} />Se connecter</> : <>Recevoir un code<ArrowRight size={17} /></>}</button>
          {sent && <button type="button" className="btn subtle block" onClick={() => { setSent(false); setCode(""); setError(null); }}>Changer de numéro</button>}
        </form>
      </div>
    </div>
  );
}
